// Activity Connection - Calendar Builder
// Author: Chau Cao

import User from '../model/User'
import { currentUser } from './CurrentUserReducer'

export const initialState = {
	currentUser: User.default()
}

export function clipArtManagementApp(state = initialState, action) {
	var result = {
		currentUser: currentUser(state.currentUser, action)
	}
	return result
}



// WEBPACK FOOTER //
// ./src/data/ClipArtManagementReducer.js